import { Box, Flex } from '@chakra-ui/react';
import { Paragraph, Toggle, Tooltip } from 'ui-components';
import { Feature } from '~/components/Feature';
import { FEATURE_FLAGS } from '~/constants';

interface Props {
  isToggled: boolean;
  onToggle: (toggle: boolean) => void;
  isDisabled?: boolean;
  tooltip?: string;
}

export const EnableSmartProfile: React.FC<Props> = ({
  isToggled,
  onToggle,
  isDisabled,
  tooltip,
}) => (
  <Feature name={FEATURE_FLAGS.foamSmartCreatorProfiles}>
    <Flex alignItems="center" justifyContent="space-between" gap={2}>
      <Box flex="1">
        <Paragraph size="lg" fontWeight="medium">
          Enable Smart Profiles:
        </Paragraph>
        <Paragraph
          size="lg"
          fontWeight="normal"
          __css={{ marginTop: '0px !important' }}
        >
          Smart Profiles uses public sources to enrich profiles with name,
          location, date of birth, gender, bio and verticals. Please verify its
          accuracy.
        </Paragraph>
      </Box>
      {tooltip ? (
        <Tooltip aria-label="A tooltip" label={tooltip} placement="top">
          <Flex justifyContent="center" alignItems="center">
            <Toggle
              checked={isToggled}
              onChange={onToggle}
              isDisabled={isDisabled}
              trackId="foam-add-talent-smart-profile-toggle"
            />
          </Flex>
        </Tooltip>
      ) : (
        <Toggle
          checked={isToggled}
          onChange={onToggle}
          isDisabled={isDisabled}
          trackId="foam-add-talent-smart-profile-toggle"
        />
      )}
    </Flex>
  </Feature>
);
